import localStorageServices from '../services/LocalStorageServices';

function tStatic(dictObj, ...params) {
  let lang = localStorageServices.getLanguage();
  // eslint-disable-next-line no-param-reassign
  lang = lang === 'ru' ? 'ru' : 'en';

  return dictObj[lang](...params);
}

export default tStatic;
